import { readLegacyVisitedIds } from "./GpsTriggerVisitedMigration";

export class GpsTriggerVisitedStore {
    static readonly storageKey = "smartguide.gps-triggering.visited.v2";
    static readonly legacyStorageKey = "smartguide.gps-triggering.visited.v1";
    private readonly visited = new Set<string>();

    constructor(
        private readonly storage: Storage | undefined = safeLocalStorage(),
        private readonly key: string = GpsTriggerVisitedStore.storageKey
    ) {
        try {
            if (this.storage?.getItem(this.key) === null) {
                const prefix = this.key.endsWith(GpsTriggerVisitedStore.storageKey)
                    ? this.key.slice(0, -GpsTriggerVisitedStore.storageKey.length) : "";
                for (const id of readLegacyVisitedIds(JSON.parse(this.storage.getItem(GpsTriggerVisitedStore.legacyStorageKey) ?? "[]"), prefix)) {
                    this.visited.add(id);
                }
                this.persist();
            }
        } catch {
            // A denied read must not prevent GPS triggering.
        }
        this.refresh();
    }

    has(id: string): boolean {
        return this.visited.has(id);
    }

    mark(id: string, basePoiId: string | null = null): void {
        this.refresh();
        if (!id.trim()) {
            return;
        }
        this.visited.add(id);
        if (basePoiId?.trim()) {
            this.visited.add(basePoiId.trim());
        }
        this.persist();
    }

    refresh(): void {
        try {
            const parsed: unknown = JSON.parse(this.storage?.getItem(this.key) ?? "[]");
            if (Array.isArray(parsed)) {
                for (const id of parsed) {
                    if (typeof id === "string" && id.trim()) {
                        this.visited.add(id);
                    }
                }
            }
        } catch {
            // Keep accepted visits when storage becomes unavailable or malformed.
        }
    }

    private persist(): void {
        try {
            this.storage?.setItem(this.key, JSON.stringify(Array.from(this.visited)));
        } catch {
            // The permanent GPS element retains this state when persistence fails.
        }
    }
}

function safeLocalStorage(): Storage | undefined {
    try {
        return globalThis.localStorage;
    } catch {
        return undefined;
    }
}
